import { FlowExportTextToBucketBlockConfigSchema } from 'flow-schema';
import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType } from '../base/baseSchema.js';

export const ExportTextToBucketBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.ExportTextToBucket),
  config: FlowExportTextToBucketBlockConfigSchema,
});
export type ExportTextToBucketBlock = z.infer<typeof ExportTextToBucketBlockSchema>;
